// src/api.ts

import axios from 'axios';

// Use environment variable for API base URL
const apiBaseUrl = process.env.REACT_APP_API_URL;
const sowStudioApiUrl = process.env.REACT_APP_SOW_STUDIO_API_URL || '/api/sow-studio';

// Create an Axios instance
const api = axios.create({
  baseURL: apiBaseUrl, // Use the API URL from environment variables
  headers: {
    'Content-Type': 'application/json',
  },
  // You can set other defaults like timeout or authorization headers here as well
  timeout: 300000,
});

export default api;

// Create an Axios instance for standard pricing tool APIs
const apiToken = axios.create({
    baseURL: apiBaseUrl, // Use the API URL from environment variables
    headers: {
      'Content-Type': 'application/json',
    },
    // You can set other defaults like timeout or authorization headers here as well
    timeout: 300000,
  });

// Add an interceptor to include the token before each request
apiToken.interceptors.request.use(
    (config: any) => {
      // Get the token from localStorage (or sessionStorage, cookies, etc.)
      const token = localStorage.getItem('login_token'); // Adjust based on where you store the token

      // If the token exists, add it to the headers
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    },
    (error: any) => {
      // Handle errors in the request setup
      return Promise.reject(error);
    }
  );

// Create an Axios instance for SOW Studio APIs
const sowStudioApi = axios.create({
    baseURL: sowStudioApiUrl,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 300000,
  });

// Add an interceptor to include the token before each request
sowStudioApi.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem('login_token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

export { apiToken, sowStudioApi };
